import { render, staticRenderFns } from "./withdraw-records.vue?vue&type=template&id=54407ce4"
import script from "./withdraw-records.vue?vue&type=script&lang=js"
export * from "./withdraw-records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports